<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import PluginMenuLayout from '~/components/App/NewHeader/PluginsMenu/Layout/index.vue'
import Icon from '~/components/Icon/Legacy/index.vue'

interface Iprops {
  alt?: boolean
}

const props = defineProps<Iprops>()

const { colors } = useTheme()
const openMenuState = useHeaderMenusActive()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')
</script>

<template>
  <Transition :name="isMobile ? undefined : 'slide'">
    <div v-show="openMenuState.plugins" class="container-plugins-menu" :class="{ alt: props?.alt }">
      <div class="content-plugins-menu">
        <div class="component">
          <PluginMenuLayout
            title="Magic Keys"
            emphasis-text="New!"
            subtitle="Create Snippets for repetitive text, Add hotkeys to your prompts, save, create and collect new solutions in a simple and minimalist interface."
            image-position="left"
            primary-button-text="Install Magic Keys"
            primary-button-url="https://chromewebstore.google.com/u/1/detail/magic-keys-by-snack-promp/ibcmobjkpcabelpfkeohflbhjeojhfdk"
            primary-button-icon-position="left"
            :primary-button-background-color="colors.darkPurple"
            title-check="Free and Paid Plans Available"
            text-check="Enjoy a free trial period"
          >
            <template #icon>
              <div w-22px h-22px center z-1>
                <Icon name="magic" :fill="colors.darkPurple" w-25px h-25px />
              </div>

              <div w-22px h-22px center absolute left-18px>
                <Icon name="google" w-full fill-white />
              </div>
            </template>

            <template #image>
              <div class="image-container">
                <img class="image" src="~assets/images/LucasHire/de5978846e5c816a2f1286d1e2ec5107.webp">
              </div>
            </template>

            <template #primaryButtonIcon>
              <Icon name="magic" fill-transparent w-25px h-25px />
            </template>
          </PluginMenuLayout>
        </div>

        <div class="component">
          <PluginMenuLayout
            title="Snack Prompt X ChatGPT"
            subtitle="All Snack Prompt features directly inside ChatGPT. Create, save, discover and sell prompts without leaving ChatGPT's interface."
            primary-button-text="Install our ChatGPT Plugin"
            primary-button-url="https://chromewebstore.google.com/detail/chatgpt-snack-prompt/lgpdceoebipofiijjgpiedpfcdenkndi"
            :color-background="isMobile ? colors.white : colors.grayLighter"
            title-check="Core Features Free Forever"
            text-check="Enjoy all features with a free version"
          >
            <template #icon>
              <div w-22px h-22px rounded-full center p-3px :style="{ backgroundColor: '#1FA280' }" z-1>
                <Icon name="gpt-logo" w-full mt-1px ml-1px fill-white />
              </div>

              <div w-22px h-22px center absolute left-18px>
                <Icon name="google" w-full fill-white />
              </div>
            </template>

            <template #image>
              <div class="image-container">
                <img class="image" src="~assets/images/LucasHire/5db279c898ab46bae8ab339791e81deb.webp">
              </div>
            </template>

            <template #primaryButtonIcon>
              <Icon name="arrow-thin" w-12px h-12px transform fill-white :style="{ rotate: '-90deg' }" />
            </template>
          </PluginMenuLayout>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.container-plugins-menu {
  width: 100%;
  position: absolute;
  top: 0;
  display: flex;
  z-index: 2;
  transition: 0.3s all;
  --at-apply: bg-white border-b-1 border-light-bluish;

  @media screen and (max-width: 768px) {
    position: static;
    min-height: unset;
    transition: none;
  }

  &.alt {
    top: 125px;
  }

  .content-plugins-menu {
    width: 100%;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  .image-container {
    width: 100%;
    padding: 2px;

    .image {
      width: 100%;
      height: 160px;
      object-position: top;
      object-fit: cover;
      margin: 0 0 30px 0;
      border-radius: 6px 6px 0 0;

      @media screen and (min-width: 769px) {
        width: 170px;
        min-width: 250px;
        height: 190px;
        object-position: center;
        border-radius: 8px;
      }
    }
  }
}
</style>
